<script lang="ts" setup>
import { useLocale } from '@/plugins/translation';
import { useDisplay } from 'vuetify';

type Props = {
  absolute?: boolean;
};

const { xs } = useDisplay();

withDefaults(defineProps<Props>(), { absolute: false });
const emit = defineEmits<{
  (e: 'back'): void;
}>();

const { t, l } = useLocale();
</script>

<template>
  <v-btn
    :ripple="{ class: 'text-primary' }"
    variant="text"
    class="back-btn rounded"
    :class="[absolute ? 'back-btn-absolute' : '', xs ? 'justify-start' : '']"
    color="on-surface-variant"
    @click="emit('back')"
  >
    <v-icon>mdi-chevron-left</v-icon>
    <span>
      {{ t(l.label_go_back) }}
    </span>
  </v-btn>
</template>

<style scoped lang="scss">
.back-btn {
  width: auto;
  text-transform: none;
  font-size: 16px;
  &:hover {
    .v-icon {
      left: -4px;
    }
  }
  .v-icon {
    left: -1px;
    transition: all ease 0.25s;
    position: relative;
  }
  &-absolute {
    position: absolute;
    left: 0;
  }
}
</style>
